import axios from 'axios'
//axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpREquest'
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
//axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,HEAD,POST,OPTIONS,PUT'
// axios.defaults.headers.common['X-CSRF-TOKEN'] = '';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
var apicon = {
  getApiBaseUrl: function () {
    //return 'http://127.0.0.1:8000/' //TEST
    return 'https://api.sistemasinx.com/' //Production NEW
  },
  setAuthHeaders () {
    const token = localStorage.getItem('jwt');
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  },
  intercept:async function(){
    //Interceptor
    await axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if(401 === error.response.status){
            localStorage.removeItem('userid');
            localStorage.removeItem('user');
            localStorage.removeItem('jwt');
            localStorage.removeItem('cliente');
            //this.$router.go('/login');
            window.location.reload();
        }else {
            return Promise.reject(error);
        }
    });
    //Interceptor
},
  // #region CRUD
  getDataApi: async function (url) {
    await this.intercept();
    var datos = []
    await axios.get(url).then(response => {
      datos = response.data
    }).catch(function (error) {
      if (error.response) {
        var msg = error.response.data.message
        datos = {
          status: 'Error',
          message: msg.substring(0, (msg.indexOf(':') + 1))
        }
      }
    })
    return datos
  },
  saveDataApi: async function (url, dataSave) {
    await this.intercept();
    var datos = []
    await axios.post(url, dataSave).then(response => {
      datos = response.data
    }).catch(function (error) {
      if (error.response) {
        datos = error.response.data
      }
    })
    return datos
  },
  updateDataApi: async function (url, dataUpdate) {
    await this.intercept();
    var datos = []
    await axios.put(url, dataUpdate).then(response => {
      datos = response.data
    }).catch(function (error) {
      if (error.response) {
        var msg = error.response.data.message
        datos = {
          status: 'Error',
          message: msg.substring(0, (msg.indexOf(':') + 1))
        }
      }
    })
    return datos
  },
  deleteDataApi: async function (url) {
    await this.intercept();
    var datos = []
    await axios.delete(url).then(response => {
      datos = response.data
    }).catch(function (error) {
      if (error.response) {
        var msg = error.response.data.message
        datos = {
          status: 'Error',
          message: msg.substring(0, (msg.indexOf(':') + 1))
        }
      }
    })
    return datos
  },
  downloadDataApi: async function (url, dataSave) {
    await this.intercept();
    var datos = [];
    await axios.post(url, dataSave,{ responseType: 'arraybuffer' }).then(response => {
      datos = response.data;
    }).catch(function (error) {
      if (error.response) {
        var msg = error.response.data.message;
        datos = {
          'status': 'Error',
          'message': msg.substring(0,(msg.indexOf(":")+1))
        };
      }
    });
    return datos;
  },
  // #endregion CRUD
}
export default apicon
